import React, { useState } from "react";
import Constants from "Utils/Constants";
import axios from "axios";
import { useDispatch } from "react-redux";
import toastMaker from "Common/toastmaker";
import errordialog from "Common/errordialog";
import Header from "Common/Header";
import Disclaimer from "./Disclaimer";
import LoginInput from "./LoginInput";
import { DialogButton } from "Common/DialogButton";
let logger = require("logger");

function Login(props) {
  const username = useFormInput(null);
  const password = useFormInput(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useDispatch();

  const handleLogin = () => {
    if (!username || !username.value || username.value.length === 0) {
      toastMaker.makeToast("Username is mandatory", {
        variant: "error",
      });
      return;
    }
    if (!password || !password.value || password.value.length === 0) {
      toastMaker.makeToast("Password is mandatory", {
        variant: "error",
      });
      return;
    }
    dispatch({ type: "ISLOADING", payload: true });
    dispatch({ type: "CLEARUSERDATA" });
    setIsLoading(true);
    return axios
      .post(Constants.loginApiPath, {
        username: username.value,
        password: password.value,
      })
      .then(({ data, data: { ok, message } }) => {
        logger.log(ok, data, message);
        dispatch({ type: "ISLOADING", payload: false });
        setIsLoading(false);
        if (ok) {
          dispatch({
            type: "LOGIN",
            payload: { ...data, username: username.value },
          });
          props.history.push(Constants.homepage);
        } else {
          errordialog.showError(message);
        }
      })
      .catch((error) => {
        logger.log("error", error);
        dispatch({ type: "ISLOADING", payload: false });
        setIsLoading(false);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errordialog.showError(error.response.data.message);
        } else {
          errordialog.showError(
            "Something went wrong. Please try again later."
          );
        }
      });
  };

  return (
    <div>
      <Header />
      <form
        style={{ width: "fit-content", margin: "10px" }}
        className="komform"
      >
        <div>
          <LoginInput
            label="Username"
            key="email"
            required
            valueholder={username}
          />
        </div>
        <div>
          <LoginInput
            label="Password"
            key="password"
            required
            valueholder={password}
            type="password"
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                handleLogin();
              }
            }}
          />
        </div>
        {true && (
          <div>
            <DialogButton
              onClick={handleLogin}
              label={isLoading ? "Logging in..." : "Login"}
              disabled={isLoading}
            />
          </div>
        )}
      </form>
      <Disclaimer />
    </div>
  );
}

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return {
    value,
    onChange: handleChange,
  };
};

export default Login;
